import template from './query-home.html';
import controller from './query-home.controller';

export default {
	template,
	controller,
	bindings: {
		ctrl: '<',
		tab: '<',
	},
};
